import { render, staticRenderFns } from "./MessegerIcon.vue?vue&type=template&id=520b5d12&"
import script from "./MessegerIcon.vue?vue&type=script&lang=js&"
export * from "./MessegerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports